import script from "./ConsumablesComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsumablesComponent.vue?vue&type=script&setup=true&lang=js"

import "./ConsumablesComponent.vue?vue&type=style&index=0&id=4849f5f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4849f5f2"]])

export default __exports__